/**
 * Check the README file for a better description of the cart structure.
 */

import {
  ADD_TO_CART,
  CART_ITEM_UPDATE,
  CLEAR_CART,
  REMOVE_FROM_CART,
  SET_ACTIVE_IDENTITY,
} from './checkoutActions';
import { cartItemExists } from './helpers';

export const initialState = {
  activeIdentity: null,
  cart: [],
  previousCart: [],
};

const checkoutReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ACTIVE_IDENTITY: {
      return {
        ...state,
        activeIdentity: action.identity,
      };
    }

    case ADD_TO_CART: {
      if (cartItemExists(state.cart, action.item)) {
        return state;
      }

      return {
        ...state,
        cart: [action.item, ...state.cart],
      };
    }

    case REMOVE_FROM_CART: {
      return {
        ...state,
        cart: state.cart.filter(item => item.id !== action.id),
      };
    }

    case CART_ITEM_UPDATE: {
      return {
        ...state,
        cart: state.cart.map(item => {
          if (item.id === action.id) {
            return {
              ...item,
              ...action.data,
            };
          }

          return item;
        }),
      };
    }

    case CLEAR_CART: {
      return {
        ...state,
        cart: [],
        previousCart: [...state.cart],
      };
    }

    default:
      return state;
  }
};

export default checkoutReducer;
